module.exports = __webpack_public_path__ + "img/michiel.a4711f79.jpg";